





import { Vue, Prop, Component } from 'vue-property-decorator';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import Scenarios from '@/types/Scenarios';

const AppState = getModule(AppModule, store);

@Component
export default class GoToNextScenarioPage extends Vue {
    @Prop() pageName!: string;
    @Prop({default:false}) neverDisable!: boolean;
    scenarios: Scenarios = AppState.tableOfContents.scenarios || {};

    get disabled(){
      return this.neverDisable ? false : this.isLockedForward;
    }

    get isLockedForward(): boolean {
      return AppState.isLockedForward;
    }

    public goTo() {
      AppState.setCurrentScenarioPage(this.pageName);
    }
}
